/* KHACHANE 2026 · moteur de motion partagé — v2
   1. Révélations au scroll + compteurs (IntersectionObserver, aucune dépendance)
   2. Couche GSAP progressive (CDN, différée, jamais en reduced-motion) :
      - marquee incliné par la vélocité du scroll (l'eau a de l'inertie)
      - parallaxe de secours quand animation-timeline: view() manque
      - boutons magnétiques (pointeurs fins uniquement) */
(function () {
  'use strict';
  if (window.__kh2026) return;
  window.__kh2026 = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* ---------- 1. Révélations + compteurs ---------- */

  function runCounter(el) {
    if (el.__khDone) return;
    el.__khDone = true;
    var target = parseInt(el.getAttribute('data-kh-count'), 10);
    if (isNaN(target)) return;
    if (reduce.matches) { el.textContent = String(target); return; }
    var dur = parseInt(el.getAttribute('data-kh-count-duration'), 10) || 1400;
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = String(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initReveals() {
    var revealEls = document.querySelectorAll('[data-kh-reveal]:not(.kh-inview)');
    var countEls = document.querySelectorAll('[data-kh-count]');

    if (reduce.matches || !('IntersectionObserver' in window)) {
      revealEls.forEach(function (el) { el.classList.add('kh-inview'); });
      countEls.forEach(runCounter);
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('kh-inview');
        if (entry.target.hasAttribute('data-kh-count')) runCounter(entry.target);
        entry.target.querySelectorAll('[data-kh-count]').forEach(runCounter);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

    revealEls.forEach(function (el) { io.observe(el); });
    countEls.forEach(function (el) { io.observe(el); });

    /* Boucles infinies (marquee, vagues) : pause hors écran */
    var loopIo = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('kh-loop-off', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    document.querySelectorAll('[data-kh-loop]:not([data-kh-loop-on])').forEach(function (el) {
      el.setAttribute('data-kh-loop-on', '');
      loopIo.observe(el);
    });
  }

  /* ---------- 2. Couche GSAP progressive ---------- */

  var GSAP_CORE = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/gsap.min.js';
  var GSAP_ST = 'https://cdn.jsdelivr.net/npm/gsap@3.13.0/dist/ScrollTrigger.min.js';
  var gsapLoading = false;

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.defer = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  /* .kh-ho-btn--primary : CTA du hero, magnétisé sans modifier sa section.
     .kh-st__img : image de kh-story, parallaxe de secours hors animation-timeline. */
  var MAGNETIC = '[data-kh-magnetic], .kh-ho-btn--primary';
  var PARALLAX = '[data-kh-parallax], .kh-st__img';

  /* Ne télécharger GSAP que si un effet va RÉELLEMENT tourner ici :
     - skew : partout (fonctionne aussi au scroll tactile)
     - parallaxe : seulement si animation-timeline: view() manque
     - magnétique : seulement sur pointeur fin avec survol */
  function needsGSAP() {
    if (document.querySelector('[data-kh-skew]')) return true;
    var hasViewTimeline = window.CSS && CSS.supports && CSS.supports('animation-timeline: view()');
    if (!hasViewTimeline && document.querySelector(PARALLAX)) return true;
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches && document.querySelector(MAGNETIC)) return true;
    return false;
  }

  function ensureGSAP() {
    if (reduce.matches || !needsGSAP() || gsapLoading) return;
    if (window.gsap && window.ScrollTrigger) { enhance(); return; }
    gsapLoading = true;
    loadScript(GSAP_CORE)
      .then(function () { return loadScript(GSAP_ST); })
      .then(function () {
        window.gsap.registerPlugin(window.ScrollTrigger);
        gsapLoading = false;
        enhance();
      })
      .catch(function () { gsapLoading = false; /* dégradation silencieuse : la base IO suffit */ });
  }

  function enhance() {
    if (!window.gsap || reduce.matches) return;
    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;

    /* Marquee : inclinaison par vélocité de scroll, retour élastique */
    var skewEls = Array.prototype.slice.call(document.querySelectorAll('[data-kh-skew]:not([data-kh-on])'));
    if (skewEls.length) {
      skewEls.forEach(function (el) { el.setAttribute('data-kh-on', ''); });
      var proxy = { skew: 0 };
      var clampSkew = gsap.utils.clamp(-7, 7);
      var setters = skewEls.map(function (el) { return gsap.quickSetter(el, 'skewX', 'deg'); });
      ScrollTrigger.create({
        onUpdate: function (self) {
          var v = clampSkew(self.getVelocity() / -350);
          if (Math.abs(v) > Math.abs(proxy.skew)) {
            proxy.skew = v;
            gsap.to(proxy, {
              skew: 0,
              duration: 0.9,
              ease: 'power3',
              overwrite: true,
              onUpdate: function () {
                for (var i = 0; i < setters.length; i++) setters[i](proxy.skew);
              }
            });
          }
        }
      });
    }

    /* Parallaxe de secours : uniquement là où animation-timeline: view() manque */
    if (!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'))) {
      document.querySelectorAll(PARALLAX).forEach(function (img) {
        if (img.hasAttribute('data-kh-on')) return;
        img.setAttribute('data-kh-on', '');
        var frame = img.parentElement;
        gsap.set(img, { height: '118%' });
        gsap.fromTo(img, { yPercent: -8 }, {
          yPercent: 0,
          ease: 'none',
          scrollTrigger: { trigger: frame, start: 'top bottom', end: 'bottom top', scrub: true }
        });
      });
    }

    /* Boutons magnétiques : pointeurs fins avec survol uniquement */
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.querySelectorAll(MAGNETIC).forEach(function (btn) {
        if (btn.hasAttribute('data-kh-on')) return;
        btn.setAttribute('data-kh-on', '');
        var xTo = gsap.quickTo(btn, 'x', { duration: 0.4, ease: 'power3' });
        var yTo = gsap.quickTo(btn, 'y', { duration: 0.4, ease: 'power3' });
        var cx = 0, cy = 0;
        /* mesure unique à l'entrée (transform ≈ 0), aucune lecture pendant le mouvement */
        btn.addEventListener('mouseenter', function () {
          var r = btn.getBoundingClientRect();
          cx = r.left + r.width / 2;
          cy = r.top + r.height / 2;
        });
        btn.addEventListener('mousemove', function (e) {
          xTo((e.clientX - cx) * 0.32);
          yTo((e.clientY - cy) * 0.32);
        });
        btn.addEventListener('mouseleave', function () {
          gsap.to(btn, { x: 0, y: 0, duration: 0.7, ease: 'elastic.out(1, 0.45)' });
        });
      });
    }

    ScrollTrigger.refresh();
  }

  /* ---------- Initialisation ---------- */

  function init() {
    initReveals();
    ensureGSAP();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Éditeur de thème : ré-initialiser après rechargement d'une section */
  document.addEventListener('shopify:section:load', init);
})();
